module.exports = __webpack_public_path__ + "assets/img/tx101c_4.ae04c713.jpg";